/**
 *
 * Asynchronously loads the component for Ben008
 * Author: Locnt
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
